"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Special.css");
var _Special2 = _interopRequireDefault(require("./Special.variant"));
var Specials = function Specials(props) {
  var type = props.type,
    specials = props.specials,
    rest = (0, _objectWithoutProperties2["default"])(props, ["type", "specials"]);
  var Special = _Special2["default"][type];
  return /*#__PURE__*/_react["default"].createElement(Special, (0, _extends2["default"])({
    specials: specials
  }, rest));
};
Specials.propTypes = {
  specials: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired,
  type: _propTypes["default"].oneOf(['default', 'carousel']),
  autoScroll: _propTypes["default"].bool
};
Specials.defaultProps = {
  type: 'default',
  autoScroll: true
};
var _default = Specials;
exports["default"] = _default;